import {CountAggregationFunction} from "@ispm/shared/aggregation-functions/count-aggregation-function";
import {SumAggregationFunction} from "@ispm/shared/aggregation-functions/sum-aggregation-function";
import {get} from "lodash";
import {IAggregationFunction} from "@ispm/dynamic-form/interfaces/IAggregationFunction.interface";

export class AggregationFactory{
/*  private enumMap:Map<any,any> = new Map();
  private countAggregationFunction: CountAggregationFunction;
  private sumAggregationFunction: SumAggregationFunction;*/

/*setMapData(){
  this.enumMap.set(aggregationFunctions.count,this.countAggregationFunction);
  this.enumMap.set(aggregationFunctions.sum,this.sumAggregationFunction);
}*/
//
public executeAggregation(inputData:Array<any>,aggFunction:string,hasFilter:boolean,filterExpression:Object):number{
  let aggFunctionObject:IAggregationFunction = this.getAggregationObject(aggFunction);
  return aggFunctionObject.performAggregation(inputData,hasFilter,filterExpression);

}

public getAggregationObject(aggregationFunction:string):IAggregationFunction{
  switch (aggregationFunction){
    case "count":
      return new CountAggregationFunction();
      break;
    case "sum":
      return new SumAggregationFunction();
      break;

  }
}

public getPropertyValue(input: Object,aggConfig:string):any{
  //check how to convert to given type
  return get(input,aggConfig);
}


}


export enum aggregationFunctions{
  count,
  sum,
  min,
  max,
  average,
}
